import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';

import styles from './styles.module.scss';

interface Props {
    note: string;
}

function CouponNote({ note }:Props) {
  return (
        <Column className={styles.container}
                fullWidth
                spacing={8}>
            <Text size='xl' fontWeight='bold' color={colors.gray7}>
                유의사항
            </Text>
            <Column className={styles.notes}
                    fullWidth
                    spacing={4}>
                <Text color={colors.gray7} className={styles.list} as='div'
                dangerouslySetInnerHTML={{ __html: note }} />
            </Column>
        </Column>
  );
}

export default CouponNote;
